import React from 'react';
import Combobox from '@ls/react-combobox-grid';
import transactionEffects from 'state/selections/TransactionEffects'
import {txEffectColumnDef} from 'state/selections/TransactionEffects'
import { useDispatch, useSelector } from 'react-redux';
import { setTransactionEffectFilter } from 'state/selections/actions';
import SelectionState from 'state/selections/SelectionState';

import {
  selectSelectedTransactionEffectFiltervalues
} from 'state/selections/selectors';

const TransactionEffectFilter = props => {
const dispatch = useDispatch();
const values = useSelector(
  selectSelectedTransactionEffectFiltervalues(SelectionState.UNCOMMITTED)
);

const options = transactionEffects.map(transcationEffect  =>  ({transcationEffect}));

const onChange = React.useCallback(
  transactionEffects => {
    dispatch(setTransactionEffectFilter(transactionEffects));
  },
  [dispatch]
);
return (

    <Combobox
      placeholder="Transaction Effects..."
      options={options}
      onChange={onChange}
      value={values}
      label={"Transaction Effects"}
      valueKey="transcationEffect"
      labelKey="transcationEffect"
      columnDefs={txEffectColumnDef}
      variation={1}
      multi
    />
    
  );
}

export default TransactionEffectFilter
